const SESSION_KEYS = {
  UID: 'app_uid',
  TOKEN: 'app_token',
} as const

/**
 * Reads uid and token from URL query params, stores them in session storage,
 * and removes them from the URL
 */
const initializeSessionFromQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const uid = urlParams.get('uid')
  const token = urlParams.get('token')

  // Store in session storage if present
  if (uid) {
    sessionStorage.setUid(uid)
  }
  if (token) {
    sessionStorage.setToken(token)
  }

  // Remove from URL if either param was present
  if (uid || token) {
    urlParams.delete('uid')
    urlParams.delete('token')

    const newSearch = urlParams.toString()
    const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${window.location.hash}`

    window.history.replaceState({}, '', newUrl)
  }
}

/**
 * Reads uid and token from environment variables and stores them in session storage
 */
const initializeSessionFromEnv = () => {
  const uid = import.meta.env.VITE_APP_UID as string | undefined
  const token = import.meta.env.VITE_APP_TOKEN as string | undefined

  // Store in session storage if present
  if (uid) {
    sessionStorage.setUid(uid)
  }
  if (token) {
    sessionStorage.setToken(token)
  }
}

export const sessionStorage = {
  setUid: (uid: string) => {
    window.sessionStorage.setItem(SESSION_KEYS.UID, uid)
  },

  getUid: (): string | null => {
    return window.sessionStorage.getItem(SESSION_KEYS.UID)
  },

  setToken: (token: string) => {
    window.sessionStorage.setItem(SESSION_KEYS.TOKEN, token)
  },

  getToken: (): string | null => {
    return window.sessionStorage.getItem(SESSION_KEYS.TOKEN)
  },

  clear: () => {
    window.sessionStorage.removeItem(SESSION_KEYS.UID)
    window.sessionStorage.removeItem(SESSION_KEYS.TOKEN)
  },

  initializeSessionFromQueryParams,
  initializeSessionFromEnv,
}
